import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_PAYEE } from "..";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";
import { useQueryRequirementsList } from "../../../query/requirements/queries/useQueryRequirementsList";
import { useUserId } from "../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";

export const RouteTaxPayeeOnboarding: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const queryFeatureFlags = useFeatureFlags();

  const queryRequirements = useQueryRequirementsList({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      },
      requirementType: RequirementType.PayoutMethod
    }
  });

  const requirements = queryRequirements.data || [];

  const hasPayoutMethodRequirement = requirements.some(
    requirement => requirement.requirementType === RequirementType.PayoutMethod
  );

  const taxPayeeOnboardingModules: OnboardingModule[] = useMemo(() => {
    const steps: OnboardingModule[] = [
      {
        type: "create_account",
        options: {
          accountTypes: ["Business", "Individual"],
          verificationLevel: "Tax",
          show1099Message: true,
          allowUSInternationalPerson:
            queryFeatureFlags.data?.internationalUsPerson
        }
      },
      {
        type: "certify_tax_payer_info"
      }
    ];

    if (hasPayoutMethodRequirement) {
      steps.push({
        type: "payout_method"
      });
    }

    return steps;
  }, [
    hasPayoutMethodRequirement,
    queryFeatureFlags.data?.internationalUsPerson
  ]);

  return (
    <OnboardingFlow
      isLoading={queryRequirements.isInitialLoading}
      basePath={PATH_ONBOARDING_TAX_PAYEE}
      modules={taxPayeeOnboardingModules}
      onSuccess={() => {
        history.push("/member/dashboard");
      }}
    />
  );
};
